import { InMemoryCache } from 'apollo-cache-inmemory';
import { CachePersistor } from 'apollo-cache-persist';
import { ApolloClient } from 'apollo-client';
import { from } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from "apollo-link-error";
import { createHttpLink } from 'apollo-link-http';
import { RestLink } from 'apollo-link-rest';
import fp from 'lodash/fp';
import actions from './state/actions';
import { Instagram } from './type-patchers';

const SCHEMA_VERSION = '1.3';

async function createApolloClient(store) {
  const cache = new InMemoryCache();
  const storage = window.localStorage;

  const persistor = new CachePersistor({
    cache,
    storage
  });

  const schemaVersionKey = 'apollo-schema-version';
  const currentVersion = storage.getItem(schemaVersionKey);

  if (currentVersion === SCHEMA_VERSION) {
    await persistor.restore();
  } else {
    await persistor.purge();
    storage.clear(); // Just in case purge didn't clear everything out.
    storage.setItem(schemaVersionKey, SCHEMA_VERSION);
  }

  const link = from([
    setContext((_, { headers }) => ({
      headers: {
        ...headers,
        ...((Authorization) =>
          (Authorization ?
            { Authorization } :
            {})
        )(store.getState().session.idToken)
      }
    })),
    onError(({ networkError }) => {
      if (networkError && networkError.statusCode === 401) {
        store.dispatch(actions.session.unauthorised);
      }
    }),
    new RestLink({
      uri: process.env.API_URL,
      endpoints: {
        instagram: 'https://www.instagram.com'
      },
      fieldNameNormalizer: fp.camelCase,
      typePatcher: {
        Instagram: Instagram
      }
    }),
    createHttpLink({ uri: `${process.env.API_URL}/graphql` })
  ]);

  const apolloClient = new ApolloClient({
    link,
    cache,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network'
      }
    }
  });

  return apolloClient;
}

export default createApolloClient;



// WEBPACK FOOTER //
// ./src/apollo-client.js